// Exact commands survive component remount and session renewal only in this
// document. Nothing here is written to browser storage or included in URLs.
const scopes = new Map();
export function commandScope(uid, key) {
  if (!uid) throw new Error('Sign in before continuing.');
  const id = JSON.stringify([uid, key]);
  if (!scopes.has(id)) scopes.set(id, { id, pending: null, completed: null, flight: null });
  return scopes.get(id);
}
export function assertCommandScope(scope) {
  if (scopes.get(scope.id) !== scope) throw new Error('This account request ended. Reopen the current account.');
}
function consentRejectedBeforeWrite(path, error) {
  // The presentation/document checks follow replay; explicit input checks precede it;
  // all three precede its first mutation. No other remote error proves absence.
  return path === 'identity/consent/accept' && (
    error?.code === 'HUMAN_CONSENT_PRESENTATION_STALE' && error.status === 409
    || error?.code === 'HUMAN_CONSENT_REQUIRED_DOCUMENT_NOT_ACCEPTED' && error.status === 400
    || error?.code === 'HUMAN_CONSENT_EXPLICIT_ACCEPTANCE_REQUIRED' && error.status === 400);
}
export function executeCommand(scope, path, body, send, validate) {
  assertCommandScope(scope);
  if (scope.pending && scope.pending.path !== path) throw new Error('Retry the unconfirmed change before starting a different change.');
  if (scope.flight) return scope.flight;
  if (!scope.pending) scope.pending = { path, body: JSON.parse(JSON.stringify(body)), uncertain: false };
  const pending = scope.pending;
  const flight = Promise.resolve().then(async () => {
    assertCommandScope(scope);
    let result;
    try { result = await send(pending.path, pending.body); }
    catch (error) {
      assertCommandScope(scope);
      if (!pending.uncertain && consentRejectedBeforeWrite(pending.path, error)) scope.pending = null;
      else pending.uncertain = true;
      throw error;
    }
    assertCommandScope(scope);
    try { validate(result); } catch (error) { pending.uncertain = true; throw error; }
    scope.completed = { path: pending.path, body: pending.body, result }; scope.pending = null;
    return scope.completed;
  }).finally(() => { if (scope.flight === flight) scope.flight = null; });
  scope.flight = flight; return flight;
}
export function clearTmsCommandCustody() {
  for (const scope of scopes.values()) { scope.pending = null; scope.completed = null; }
  scopes.clear();
}
if (typeof window !== 'undefined') window.addEventListener('pagehide', event => { if (!event.persisted) clearTmsCommandCustody(); });
